import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const StakePushOrangeDoubleStarMultiplier: FC<IllustrationProps> = (
  allProps,
) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="StakePushOrangeDoubleStarMultiplier"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M3.81299 11.5575C3.81299 7.5934 7.0265 4.37988 10.9906 4.37988H37.0093C40.9733 4.37988 44.1868 7.59339 44.1868 11.5575V28.0714C44.1868 30.3588 43.0966 32.5092 41.2515 33.8611L28.1848 43.4355C27.0159 44.292 25.6044 44.7537 24.1553 44.7537C22.7274 44.7537 21.3356 44.3054 20.1762 43.472L6.80132 33.8583C4.92522 32.5098 3.81299 30.3406 3.81299 28.0301V11.5575Z"
            fill="black"
          />
          <path
            d="M3.81299 14.1463C3.81299 10.1823 7.0265 6.96875 10.9906 6.96875H37.0093C40.9733 6.96875 44.1868 10.1823 44.1868 14.1463V30.6603C44.1868 32.9476 43.0966 35.098 41.2515 36.45L28.1848 46.0243C27.0159 46.8808 25.6044 47.3426 24.1553 47.3426C22.7274 47.3426 21.3356 46.8943 20.1762 46.0609L6.80132 36.4472C4.92522 35.0986 3.81299 32.9295 3.81299 30.619V14.1463Z"
            fill="#EF9D7B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.9907 0.566895H37.0093C43.0793 0.566895 48 5.48758 48 11.5575V28.0715C48 31.574 46.3306 34.8668 43.5053 36.937L30.4386 46.5113C28.6159 47.8469 26.415 48.5669 24.1554 48.5669C21.9289 48.5669 19.7587 47.8678 17.9508 46.5683L4.57588 36.9546C1.7031 34.8897 0 31.5681 0 28.0302V11.5576C0 5.48759 4.92068 0.566895 10.9907 0.566895ZM10.9907 4.37998C7.02659 4.37998 3.81308 7.59349 3.81308 11.5576V28.0302C3.81308 30.3407 4.92531 32.5099 6.80141 33.8584L20.1763 43.4721C21.3357 44.3055 22.7275 44.7538 24.1554 44.7538C25.6045 44.7538 27.016 44.2921 28.1849 43.4356L41.2516 33.8612C43.0967 32.5093 44.1869 30.3589 44.1869 28.0715V11.5575C44.1869 7.59349 40.9734 4.37998 37.0093 4.37998H10.9907Z"
            fill="#EF9D7B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.1927 44.4422C25.5373 44.6474 24.8507 44.7537 24.1553 44.7537C22.7274 44.7537 21.3356 44.3054 20.1762 43.472L7.96729 34.6964V19.3877H26.1927V44.4422Z"
            fill="url(#paint0_linear_8618_11686)"
            fill-opacity="0.6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40.68 34.2799L28.772 43.0053V23.4297H40.68V34.2799Z"
            fill="url(#paint1_linear_8618_11686)"
            fill-opacity="0.6"
          />
          <path
            d="M25.6069 18.7057C25.6069 18.7057 25.0306 18.5134 24.2302 18.2468C21.4692 17.3265 19.2713 15.1287 18.351 12.3678C18.0845 11.5672 17.8922 10.9909 17.8922 10.9909C17.7756 10.6413 17.4483 10.4055 17.0797 10.4055C16.7112 10.4055 16.384 10.6414 16.2673 10.991C16.2673 10.991 16.0751 11.5672 15.8086 12.3676C14.8883 15.1286 12.6904 17.3265 9.92956 18.2468C9.12896 18.5134 8.55269 18.7057 8.55269 18.7057C8.20309 18.8223 7.96729 19.1495 7.96729 19.5181C7.96729 19.8866 8.20315 20.2139 8.55275 20.3305C8.55275 20.3305 9.12902 20.5227 9.92933 20.7892C12.6904 21.7095 14.8883 23.9074 15.8086 26.6682C16.0751 27.4688 16.2673 28.0451 16.2673 28.0451C16.384 28.3947 16.7111 28.6306 17.0797 28.6306C17.4483 28.6306 17.7756 28.3947 17.8922 28.0451C17.8922 28.0451 18.0845 27.4689 18.351 26.6684C19.2714 23.9075 21.4692 21.7095 24.23 20.7893C25.0306 20.5227 25.6069 20.3305 25.6069 20.3305C25.9565 20.2139 26.1924 19.8867 26.1924 19.5181C26.1924 19.1495 25.9565 18.8223 25.6069 18.7057Z"
            fill="white"
          />
          <path
            d="M40.2976 22.8991C40.2976 22.8991 39.9211 22.7735 39.3981 22.5993C37.5941 21.998 36.158 20.5619 35.5567 18.758C35.3825 18.2349 35.2569 17.8583 35.2569 17.8583C35.1807 17.6299 34.9668 17.4758 34.726 17.4758C34.4852 17.4758 34.2714 17.6299 34.1952 17.8584C34.1952 17.8584 34.0696 18.2349 33.8955 18.7579C33.2941 20.5619 31.8581 21.998 30.0541 22.5993C29.531 22.7735 29.1545 22.8991 29.1545 22.8991C28.926 22.9753 28.772 23.1891 28.772 23.43C28.772 23.6708 28.9261 23.8846 29.1545 23.9608C29.1545 23.9608 29.531 24.0864 30.054 24.2605C31.858 24.8618 33.2941 26.2979 33.8954 28.1018C34.0696 28.6249 34.1952 29.0015 34.1952 29.0015C34.2714 29.2299 34.4852 29.384 34.726 29.384H34.7261C34.9669 29.384 35.1807 29.2299 35.2569 29.0015C35.2569 29.0015 35.3825 28.625 35.5567 28.102C36.158 26.2979 37.5941 24.8618 39.398 24.2605C39.9211 24.0864 40.2976 23.9608 40.2976 23.9608C40.5261 23.8846 40.6802 23.6708 40.6802 23.43C40.6802 23.1891 40.5261 22.9753 40.2976 22.8991Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8618_11686"
              x1="17.08"
              y1="19.3877"
              x2="17.08"
              y2="44.7537"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF8A9" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8618_11686"
              x1="34.726"
              y1="23.4297"
              x2="34.726"
              y2="43.0053"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF8A9" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default StakePushOrangeDoubleStarMultiplier;
